import './Banking.css'
import { Box2, Box3 } from '../../general_assets/containers.js'
import Plot from 'react-plotly.js';
import { Knob } from '../../general_assets/controls.js';
import { useState } from 'react';
import { KeyPad } from '../../general_assets/keypad.js';
import rest from '../../utils/rest.js';
import { Popup } from '../../general_assets/popup.js';

export function Spread({data, refresh}) {
    const [getSelected, setSelected] = useState({elements: []})
    const [getTriggerReady, setTriggerReady] = useState({ready: false})

    function TickSaver(key) {
        // Remove from element
        if(getSelected.elements.includes(key)) {
            let temp_array = []
            getSelected.elements.forEach((item) => {
                if(item != key) {
                    temp_array.push(item)
                }
            })
            setSelected({elements: temp_array})

        } else { // Add to element
            let temp_array = getSelected.elements
            temp_array.push(key)
            setSelected({elements: temp_array})
        }

        // Check for trigger condition
        if(getSelected.elements.length >= btn_count) {
            rest.JSONRequest("bank/trigger", "GET", {}, {}).then((response) => {
                if(response.status < 400) {
                    setTriggerReady({ready: true})
                }
            })
        }
    }

    // Get total count of buttons
    const btn_count = Math.max(data ? Object.values(data.spread).reduce((cnt, curVal) => (curVal > 0) + cnt, 0) : 1, 1)

    return (<>
        <Box2 title="Spread">
            <div className='spread_stat_box'>

                <button onClick={() => {TickSaver("total")}} className={`spread_stat spread_total ${getSelected.elements.includes("total") ? "selected" : ""}`}> 
                    <h2> total </h2>
                    <h1>${data.spread["total"]} </h1>
                </button>

                {data.spread["leftover"] > 0 ? 
                <button onClick={() => {TickSaver("leftover")}} className={`spread_stat spread_total ${getSelected.elements.includes("leftover") ? "selected" : ""}`}> 
                    <h2> leftover </h2>
                    <h1>${data.spread["leftover"]} </h1>
                </button> : null}

                {Object.keys(data.spread).map((key) => {
                    if(key == "total" || key == "leftover") { return; }
                    if(data.spread[key] < 0.01) {return null}
                    return <button key={key} onClick={() => {TickSaver(key)}} className={ `spread_stat ${getSelected.elements.includes(key) ? "selected" : ""}`}> 
                        <h2>{key} </h2>
                        <h1>${data.spread[key]} </h1>
                    </button>
                })}
            </div>
        </Box2>
        {getTriggerReady.ready ? <ProcessPopup refresh={refresh} setClosed={() => {setTriggerReady({ready: false}); setSelected({elements: []})}}/> : ""}
    </>)
}

export function ProcessPopup({refresh, setClosed}) {
    const [getResponse, setResponse] = useState({ready: 0, res:""})

    function ConfirmTrigger() {
        setResponse({ready: 1, res: "Requesting..."})
        rest.JSONRequest("bank/trigger/confirm", "GET", {}, {}).then((response) => {
            if(response.status == 200) {
                setResponse({ready: 2, res: response.data.log})
                setTimeout(() => {
                    refresh()
                    setClosed({ready: false})
                }, 5000)
            }
        })
    }

    return (
        <Popup title={"Processing Ready"}>
            <p> Click to complete weekly processing</p>
            {getResponse.ready > 0 ? <>
                <p className='text'> {getResponse.res} </p>
                <p> Closing in 5 seconds... </p>
            </> : <button className='process_btn' onClick={ConfirmTrigger}> Complete </button>}
        </Popup>
    )
}

export function Breakdown({data}) {

    let keys = Object.keys(data.breakdown)
    let vals = keys.map((key, idx) => {
        return data.breakdown[key]
    })

    return (
        <div className='plot_center'>
            <Box2 title="Breakdown">
                <Plot
                    data={[
                        {
                            labels: keys,
                            values: vals,
                            type: 'pie',
                            textinfo: 'label+percent', // Shows label and percentage
                            textfont: { color: 'white' }, // Text color
                            hoverinfo: 'label+percent', // Shows label and percentage on hover
                        }
                    ]}
                    layout={{
                        paper_bgcolor: 'rgba(0,0,0,0)', // Transparent background
                        plot_bgcolor: 'black', // Black chart area
                        font: { color: 'white' },
                        margin: { l: 40, r: 40, t: 40, b: 40 }, // Adjust margins
                        title: { text: 'Budget Breakdown', font: { color: 'white' } },
                        showlegend: false,
                    }}
                    useResizeHandler={true}
                    style={{ height: '21rem', width: '21rem' }}
                />

            </Box2>
        </div>
    )
}

export function Constants({data, refresh}) {
    const [getOpenEdit, setOpenEdit] = useState({
        open: false,
        title: ""
    })
    const [getValue, setValue] = useState(0)

    function UpdateConstant(title) {
        setValue(data.constants[title].cost)
        setOpenEdit({
            open: true,
            title: `${title}`
        })
    }

    function CloseKeypad() {
        setOpenEdit({...getOpenEdit, open: false })
    }

    function SubmitKeypad() {
        rest.JSONRequest('bank/updateconst', 'POST', {value: getValue.value, name: getOpenEdit.title}, {}).then(() => {
            refresh(1500)
        })
        setOpenEdit({...getOpenEdit, open: false })
    }

    console.log(data)

    return (
        <>
        <Box2 title="Constants" extra_classes='constants_box'>
            <div className='constants_stat_box'>
                {// Constants
                Object.keys(data.constants).map((key) => {
                    return <Box3 title={key}>
                        <div className='constants_tweeker'>
                            <h1 className='constants_field'> ${data.constants[key].cost} / {data.constants[key].time} </h1>
                            <button onClick={() => {UpdateConstant(key)}}>✎</button>
                        </div>
                    </Box3>
                })}
            </div>
        </Box2>
        {getOpenEdit.open ? <KeyPad getValue={getValue} setValue={setValue} setClosed={CloseKeypad} setSubmitted={SubmitKeypad} title={getOpenEdit.title}/> : null}
        </>
    )
}

export function FuturePayments({data}) {

    let total_val = 0
    let x = data.future.map((val, idx) => {
        total_val += val;
        return idx
    });
    console.log(data.future)

    return (
        <Box2 title="Future Payments">
            <Plot
                data={[
                    {
                        x: x,
                        y: data.future,
                        type: 'scatter',
                        mode: 'lines+markers',
                        marker: { color: '#419FEB', symbol: "diamond", size:8 },
                        fill: 'tozeroy'
                    }
                ]}
                layout={{
                    title: { text: `Total Value: $${Math.round(total_val * 100) / 100.0}`, font: { color: 'white', size: 16 } },
                    paper_bgcolor: 'rgba(0,0,0,0)', // plot background
                    plot_bgcolor: 'transparent', // chart area background
                    margin: { l: 50, r: 30, t: 30, b: 50 }, 
                    font: { color: 'white' },
                    xaxis: {
                        title: { text: 'Weeks', font: { color: 'white' } },
                        gridcolor: '#383838ff',
                        dtick: 1,

                    },
                    yaxis: {
                        title: { text: 'Weeks Pay', font: { color: 'white' } },
                        gridcolor: '#383838ff',
                        range: [0, Math.max(data.future)]
                    },
                    shapes: [
                        {
                            type: 'rect',
                            xref: 'paper',
                            yref: 'paper',
                            x0: 0,
                            y0: 0,
                            x1: 1,
                            y1: 1,
                            line: {
                                color: 'white',
                                width: 0.2,
                            },
                        }
                    ],
                }}
                config={{
                    responsive: true
                }}
                useResizeHandler={true}
                className="future_graph"
            />
        </Box2>
    )
}